import { Platform, StyleSheet } from 'react-native';
import * as AppConstants from '@/utilities/AppConstants';

export const TAGLINE = "The Rabbl dating app platform";

export const CREATOR_CUT = "50%";

export const LAYOUT_STATEFUL = "(stateful)";
export const LAYOUT_CONTEXTFUL = "(contextful)";
export const ROUTING_PREFIX = "/" + LAYOUT_STATEFUL + "/" + LAYOUT_CONTEXTFUL;
export const SUBDOMAIN_HOMEPAGE_LOGGED_OUT = ROUTING_PREFIX + "/(community-loggedout-stack)/";
export const SUBDOMAIN_HOMEPAGE_LOGGED_IN = ROUTING_PREFIX + "/(community-loggedin-member-alltabs)/";
export const SUBDOMAIN_HOMEPAGE_LOGGED_IN_UNJOINED = ROUTING_PREFIX + "/(community-loggedin-nonmember-stack)/";

export const URL_PREFIX_PRODUCTION = "https://" + AppConstants.HOST;
export const URL_PREFIX_DEVELOPMENT_METRO = "http://localhost:8081";

export const REFRESH_INTERVAL_LOGGED_IN_REFRESH_MS = 10000;
export const REFRESH_INTERVAL_CHAT_REFRESH_MS = 12000;

export const APPLE_STORE_LINK = "https://testflight.apple.com/join/KesnsMsK";
export const ANDROID_STORE_LINK = "https://play.google.com/store/apps/details?id=com.rabbldating.app";

export const MIN_AGE = 18;
export const MAX_AGE = 100;

// These should match on the server side
export const MIN_COVER_CHARGE = 2.99;
export const MAX_COVER_CHARGE = 19.99;

export const DEFAULT_COVER_CHARGE_MEN = 9.99;
export const DEFAULT_COVER_CHARGE_WOMEN = MIN_COVER_CHARGE;
export const MAX_FREE_MEMBERSHIPS = 10;

export const MIN_HEIGHT_INCHES = 24;
export const MAX_HEIGHT_INCHES = 108;

export const AVERAGE_HEIGHT_MAN = 66;
export const AVERAGE_HEIGHT_WOMAN = 62;

export const BASIC_MINIMUM_WIDTH = 200;

export const MAX_WIDTH_COMFORTABLE_READING = 500;
export const MAX_WIDTH_COMFORTABLE_READING_WIDE = 900;

export const DEFAULT_VIDEO_WIDTH = BASIC_MINIMUM_WIDTH + 25;
export const DEFAULT_VIDEO_HEIGHT = BASIC_MINIMUM_WIDTH;

export const TITLE_TEXT_PADDING_LEFT = 50;
export const TITLE_TEXT_PADDING_RIGHT = 50;

export const COLOR1 = "#d5fdff";
export const COLOR2 = "#ffe3fc";
export const COLOR3 = "#B8B7B8";
export const COLOR4 = "#8678C5";
export const COLOR5 = "#9546C1";
export const COLOR6 = "#622F80";
export const COLOR7 = "#381A4A";
export const COLOR8 = "#0B0C0C";

export const LINK_SHADOW_COLOR = "#00F1FF";

export const MAIN_COLOR1 = COLOR1;
export const MAIN_COLOR2 = COLOR2;

export const SIMPLE_GLOBAL_STATE_TRANSIENT_REACT_NATIVE_PURCHASES_INITIALIZED = "react-native-purchases:initialized";

export const DRAWER_DELAY_MILLISECONDS = 1500;

export const DELETED_USER = "Deleted user";

export const PAYMENTS_LINE1 = "You can pay through the website using a credit card. Android users can also pay through the Android app. Apple users can join as a beta tester through Apple TestFlight.";

export const PROFILE_DECISION_IMAGE_DIMENSION = 64;
export const PROFILE_DECISION_TOTAL_HEIGHT = PROFILE_DECISION_IMAGE_DIMENSION + 20;

export const MAXIMUM_FILTER_MAX_DISTANCE_MILES = 25000;

export const DEFAULT_FONT_SIZE = 16;
export const DEFAULT_FONT_COLOR = "#000000";

// Start Match in utilities.rb
export const LINK_COLOR = "#BE03FD";
export const RABBL_SEARCH_RESULT_WIDTH = 167;
export const RABBL_SEARCH_RESULT_HEIGHT = 167;
export const PIP_WIDTH = 75;
export const PIP_HEIGHT = 75;
export const EMBED_HTML_FONT_SIZE = 10;
export const EMBED_BOXES_OFFSET = 4;
export const EMBED_COLOR2 = "#ffe3fc";
// End Match in utilities.rb

export const EXISING_USERS_LOGIN = "Log in";

export const STYLES = StyleSheet.create({
  rangeSliderThumb: {
    width: 15,
    height: 30,
  },
  rangeSlider: {
    width: BASIC_MINIMUM_WIDTH,
  },
  fontMono: {
    // https://stackoverflow.com/questions/38781089/font-family-monospace-monospace
    fontFamily: Platform.OS === "web" ? "monospace, monospace" : "VT323-Regular",
    fontSize: DEFAULT_FONT_SIZE,
  }
});

export const TAB_BUTTON_WIDTH = 75;
export const TAB_BUTTON_PADDING = 5;
export const TAB_BUTTON_MAX_HEIGHT = 28;
export const TAB_BUTTON_HEIGHT = TAB_BUTTON_MAX_HEIGHT + (TAB_BUTTON_PADDING * 2);

export const HIT_SLOP_SMALL = { top: 5, bottom: 5, left: 5, right: 5 };
